<script lang="ts">
    import {Link} from 'svelte-routing'
    import {getCategories} from 'src/components/main/#services/blogCategories'
    import {getArticlesByFilter} from 'src/components/main/#services/blogArticles'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import {dateFormat} from 'src/global/dateFormat'

    let tabs
    let currentPage = 0
    let perPage = 21
    let selectedCategory = { id: 0, name: 'All' }

    getCategories.send()

    $: {
        getArticlesByFilter.send({
            data: {
                categoryId: selectedCategory.id != 0 ? selectedCategory.id : undefined,
                page: currentPage + 1,
                perPage
            }
        })

        if (tabs) {
            window.scrollTo({
                top: tabs.offsetTop - 20,
                left: 0,
                behavior: 'smooth'
            })
        }
    }

    function changeTab(id, name) {
        selectedCategory = { id, name }
        currentPage = 0
    }
</script>

<div class="container">
    <div class="tabs" bind:this={tabs}>
        <div class="tab" class:active={selectedCategory.id == 0} on:click={() => {selectedCategory.id = 0}}>All</div>
        {#if !$getCategories.hasValue && $getCategories.loading}
            <div class="tab">Loading...</div>
        {:else if !$getCategories.hasValue && $getCategories.error }
            <div class="tab">Something went wrong</div>
        {:else if $getCategories.value}
            {#each $getCategories.value as { id, name }}
                <div class="tab" class:active={selectedCategory.id == id} on:click={() => {changeTab(id, name)}}>
                    {name.replace('|', '')}
                </div>
            {/each}
        {/if}
    </div>
    <div class="tab-content">
        <div class="row blog-cards">
            {#if !$getArticlesByFilter.hasValue && $getArticlesByFilter.loading}
                <div class="color-white">Loading...</div>
            {:else if !$getArticlesByFilter.hasValue && $getArticlesByFilter.error }
                <div class="color-white">Something went wrong</div>
            {:else if $getArticlesByFilter.value}
                {#if $getArticlesByFilter.value.data.length}
                    {#each $getArticlesByFilter.value.data as { title, image, shortDescription, createdAt, url }}
                        <div class="col-md-4">
                            <Link to="blog/{url}" class="blog-card">
                                <div class="image">
                                    <img src="{process.env.IMAGES_PATH}{image}" alt="">
                                </div>
                                <div class="date">{dateFormat(createdAt, 'full')}</div>
                                <div class="title">{title}</div>
                                <div class="description">{shortDescription}</div>
                            </Link>
                        </div>
                    {/each}
                {:else}
                    <div class="color-white">Empty</div>
                {/if}
            {/if}
        </div>
        {#if $getArticlesByFilter.value}
            <Pagination
                bind:currentPage={currentPage}
                totalCount={$getArticlesByFilter.value.totalCount}
                {perPage}
                categoryId={selectedCategory.id}
            />
        {/if}
    </div>
</div>

<style>
    .tabs {
        display: flex;
        flex-wrap: wrap;
        border-bottom: 2px solid #282D39;
        padding: 40px 0;
        margin-bottom: 50px;
    }

    .tab {
        font-size: 18px;
        color: #A0AEC0;
        padding: 15px 30px;
        margin: 10px 0;
        min-width: 120px;
        border: 1px solid #A0AEC0;
        border-radius: 3px;
        text-align: center;
        cursor: pointer;
        transition: .25s;
        user-select: none;
    }

    .tab:not(:last-child) {
        margin-right: 30px;
    }

    .tab.active {
        background: #FF5D1C;
        border-color: #FF5D1C;
        color: white;
    }

    .tab:not(.active):hover {
        color: #c2cdda;
        border-color: #c2cdda;
    }

    .content-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .blog-cards {
        margin: 0 -20px 10px;
    }

    .date {
        color: #505a65;
        font-size: 13px;
        margin: 20px 0 10px;
    }

    .title {
        font-size: 25px;
        line-height: 1.5;
        font-family: 'Anton', sans-serif;
        color: white;
        letter-spacing: 0.04em;
        margin-bottom: 20px;
    }

    .description {
        font-size: 16px;
        line-height: 1.6;
        color: #A0AEC0;
    }

    .tab-content :global(.blog-card) {
        position: relative;
        padding: 0 8px;
        margin-bottom: 40px;
        display: block;
    }

    .tab-content :global(.blog-card:hover:before) {
        border-color: #FE4900;
    }

    .tab-content :global(.blog-card:hover .title) {
        text-decoration: underline;
    }

    .tab-content :global(.pagination) {
        justify-content: center;
    }

    .image {
        overflow: hidden;
        height: 250px;
    }

    .image img {
        max-width: 100%;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: .25s;
    }

    .tab-content :global(.blog-card:hover .image img) {
        transform: scale(1.2) rotate(7deg);
    }

    .show-all-btn img {
        margin-left: 10px;
        transition: .25s;
    }

    .show-all-btn:hover img {
        transform: rotate(45deg);
    }

    @media(max-width: 1400px) {
        .image {
            height: 230px;
        }

        .description {
            font-size: 14px;
        }
    }

    @media(max-width: 1199px) {
        .tabs {
            padding: 30px 0;
            white-space: nowrap;
            overflow: auto;
        }

        .tab {
            font-size: 16px;
            padding: 12px 20px;
            min-width: 100px;
        }

        .tab:not(:last-child) {
            margin-right: 20px;
        }

        .image {
            height: 200px;
        }

        .title {
            font-size: 22px;
        }
    }

    @media(max-width: 991px) {
        .tabs {
            padding: 20px 0;
            margin-bottom: 30px;
        }

        .date {
            color: #7e8893;
            font-size: 12px;
        }

        .description {
            font-size: 12px;
            margin-bottom: 20px;
        }

        .image {
            height: 160px;
        }

        .title {
            font-size: 18px;
            margin-bottom: 12px;
        }

        .tab-content :global(.blog-card) {
            padding: 0;
            margin-bottom: 30px;
        }

        .blog-cards {
            margin: 0 -12px 10px;
        }
    }

    @media(max-width: 767px) {
        .tab {
            font-size: 11px;
            padding: 7px 16px;
            margin: 6px 0;
            min-width: 74px;
            color: #A0AEC0;
        }

        .tab:not(:last-child) {
            margin-right: 12px;
        }

        .tab-content :global(.blog-card) {
            padding: 0 162px 0 0;
            margin-bottom: 30px;
            min-height: 90px;
        }

        .image {
            height: 90px;
            width: 150px;
            position: absolute;
            right: 0;
            top: 0;
        }

        .date {
            color: #A0AEC0;
            margin-top: 0;
        }

        .title {
            margin-bottom: 0;
        }

        .description {
            display: none;
        }

        .tab-content :global(.blog-card:after) {
            content: "";
            width: 100%;
            height: 1px;
            background: #282d39;
            position: absolute;
            bottom: -15px;
        }
    }
</style>
